<template>
    <v-row no-gutters>

        <v-col>

            <v-card>
                <v-toolbar dense :elevation="0">
                    <v-toolbar-title>Create Contact</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           :disabled="!!errors.items.length || !formValidated"
                           @click="submit">Save
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <form>
                        <v-text-field
                                v-model="form.name"
                                v-validate="'required|min:3'"
                                :error-messages="errors.collect('form.name')"
                                label="Name"
                                data-vv-name="form.name"
                                data-vv-as="Name"
                                required
                        ></v-text-field>

                        <v-text-field
                                label="E-mail"
                                name="profile_email"
                                v-validate="'required|email'"
                                v-model="form.email"
                                :error-messages="errors.collect('form.email')"
                                data-vv-name="form.email"
                                data-vv-as="E-mail"
                                required
                                autocomplete="off"
                                @change="findCompanyByDomain"
                        ></v-text-field>
                        <v-autocomplete
                                v-model="form.company_id"
                                :loading="companies.loading"
                                :items="companies.items"
                                :search-input.sync="companies.search"
                                no-filter
                                flat
                                hide-no-data
                                clearable
                                item-text="[name]"
                                item-value="id"
                                label="Company"
                                required
                                v-validate="'required'"
                                :error-messages="errors.collect('form.client_id')"
                                data-vv-name="form.company_id"
                                data-vv-as="Company"
                        ></v-autocomplete>
                        <v-text-field
                                label="Direct Dial"
                                v-validate="''"
                                v-model="form.direct_dial"
                                :error-messages="errors.collect('form.direct_dial')"
                                data-vv-name="form.direct_dial"
                                data-vv-as="Direct Dial"
                        ></v-text-field>
                        <v-text-field
                                label="Mobile"
                                v-validate="''"
                                v-model="form.mobile"
                                :error-messages="errors.collect('form.mobile')"
                                data-vv-name="form.mobile"
                                data-vv-as="Mobile"
                        ></v-text-field>
                    </form>

                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	export default {
		data: () => ({
			form: {
				name: '',
				email: '',
				company_id: null,
				direct_dial: '',
				mobile: ''
			},
			companies: {
				loading: false,
				items: [],
				search: null,
			},
		}),
		mounted() {
			this.getCompanies();
		},
		computed: {
			formValidated() {
				return Object.keys(this.fields).some(key => this.fields[key].validated) &&
					Object.keys(this.fields).some(key => this.fields[key].valid)
			}
		},
		watch: {
			'companies.search'() {
				this.getCompanies();
			},
		},
		methods: {
			async submit() {
				if (await this.$formValidator.validate(this.form)) {
					try {
						await this.$http.post('/users', this.form)
						this.$router.push('/users')
					} catch (e) {
						this.$validationException(e)
					}
				}
			},
			async getCompanies() {
				const response = await this.$http.get('/companies/', {
					params: {
						q: this.companies.search,
						per_page: 100,
					}
				});
				this.companies.items = response.data.data;
			},
			async findCompanyByDomain() {
				const response = await this.$http.get('/companies/by-domain', {
					params: {
						domain: this.form.email.split('@')[1]
					}
				});
				if(Object.keys(response.data).length) {
					this.form.company_id = response.data.id;
					this.companies.items.push(response.data);
                } else {
					this.form.company_id = null;
				}
			},
			// companyFilter (item, queryText, itemText) {
			// 	const textOne = item.name.toLowerCase()
			// 	const textTwo = item.domain ? item.domain.toLowerCase() : ''
			// 	const searchText = queryText.toLowerCase()
            //
			// 	return textOne.indexOf(searchText) > -1 ||
			// 		textTwo.indexOf(searchText) > -1
			// },
		}
	}
</script>

<style scoped>

</style>
